/*
 * @Description: 列表页搜索框右侧搜索词
 * @Author: zhanghao@fang.com
 * @Date: 2020-07-06 09:17:56
 * @LastEditors: zhanghao@fang.com
 */ 
define('list/hotsearch',['jquery'], function(require) {
    // 列表页搜索框右侧搜索词
    $.get('/asynclist/ajax/hotsearch', (result) => {
        if(result && result.code === '200' && result.data){
            let list = '';
            result.data.forEach((item) => {
                const { normalColumnData, customColumnData } = item;
                if(item.cityName === '全国'){
                    // 闪烁
                    list += `<li class="red_color wink_dh"><a href="${item.normalColumnData.url}" target="_blank">${item.normalColumnData.title}</a></li>`;
                } else if(normalColumnData && normalColumnData.isColorRed && normalColumnData.isColorRed === '1' && customColumnData && customColumnData.customColumn1 && customColumnData.customColumn1 === '是') {
                    // 标红 加粗
                    list += `<li class="red_color"><a href="${item.normalColumnData.url}" target="_blank"><b>${item.normalColumnData.title}</b></a></li>`;
                } else if(normalColumnData && normalColumnData.isColorRed && normalColumnData.isColorRed === '1' ){
                    // 只标红
                    list += `<li class="red_color"><a href="${item.normalColumnData.url}" target="_blank">${item.normalColumnData.title}</a></li>`;
                } else if(customColumnData && customColumnData.customColumn1 && customColumnData.customColumn1 === '是'){
                    // 只加粗
                    list += `<li><a href="${item.normalColumnData.url}" target="_blank"><b>${item.normalColumnData.title}</b></a></li>`;
                } else {
                    // 默认
                    list += `<li><a href="${item.normalColumnData.url}" target="_blank">${item.normalColumnData.title}</a></li>`;
                }
            });
            if(list){
                $('#hotsearch').addClass('hot');
                $('#hotsearch').append(`<ul>${list}</ul>`);
            }
        }
    });
    
});

